<!--
This component will show an iframe with locally hosted external forms
The trick here is to wait for the load event and then observe changes in its height
-->

<template>
  <article>
    <iframe ref="iframe" :src="url" frameborder="0" allowtransparency="true" class="w-full" :height="height" />
  </article>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

interface Props {
  externalForm: string
}

const { externalForm } = defineProps<Props>()

const config = useRuntimeConfig()
const height = ref('750px')
const iframe = ref<HTMLIFrameElement | null>(null)
const url = `${config.public['wwwSiteUrl']}/externalForm/${externalForm}.html`

const onResize = () => {
  if (iframe.value) {
    height.value = iframe.value.contentDocument?.body.scrollHeight + 'px'
  }
}

const onLoad = () => {
  // Set initial size now that the iFrame has loaded
  onResize()

  // Listen for resize events
  const resizeObserver = new ResizeObserver(onResize)
  if (iframe.value) {
    resizeObserver.observe(iframe.value.contentDocument?.body as Element)
    height.value = iframe.value.contentWindow?.document.body.scrollHeight + 'px'
  }
}

// Make sure that the event listener is also removed, otherwise they will accumulate
onMounted(() => iframe.value.addEventListener('load', onLoad))
onUnmounted(() => iframe.value.removeEventListener('load', onLoad))
</script>
